<template>
  <v-layout row justify-center style=" background: white;">
    <v-flex style="background: white;">
      <v-card class="justify-center" color="black" dark>
        <div class="logo-img"></div>
        <div class="container-notification">
          <img class="align-center" src="/logo-mikro.png" alt="">
          <v-flex xs10 offset-xs1 sm8 offset-sm2 md6 offset-md3 class="text-xs-center">
            <h2>A böngésző nem támogatott, használjon <a href="https://www.google.com/chrome/">Chrome-ot</a> vagy <a href="https://www.mozilla.org/es-ES/firefox/features/fast/">Firefoxot</a></h2>
          </v-flex>
        </div>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
  import { mapActions } from 'vuex'
  export default {
    data () {
      return {
        dialog: true,
        loading: false,
      }
    },
    props: {
      btnTitle: String,
      watching: Object
    },
    computed: {
      timestamp () {
        return new Date(((this.watching || {}).timestamp || 0) * 1000).toISOString().substr(11, 8)
      }
    },
    methods: {
      ...mapActions(['checkSubscription', 'checkActiveUser']),
      async openVideo () {
        this.loading = true
        const activeUser = await this.checkActiveUser()
        if (activeUser) {
          // User active in other device
          alert('Solo puedes reproducir desde un dispositivo a la vez.')
          this.loading = false
          return
        }
        const status = await this.checkSubscription()
        console.log({watching: this.watching, status})
        if (status === 'pending') await this.checkSubscription()
        this.loading = false
        if (this.watching && this.watching.timestamp > 5) {
          this.dialog = true
        } else {
          this.$emit('openVideo')
          this.dialog = false
          return false
        }
      },
      redirect () {
        history.go(-1)
      }
    }
  }
</script>

<style scoped>
  .align-center {
    margin-top: 10%;
    margin-left: calc(50% - 165px);
  }
  .align-center-btn {
    display: block;
    margin-left: calc(50% - 82px);
  }
  .button-appstore {
    width: 150px;
    margin: auto 10px;
  }
  .justify-center {
    height: 100vh;
  }
</style>
<style>
  .align-center-btn * {
    width: 135px;
  }
</style>
